import * as React from "react";
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.688 2.343a2.588 2.588 0 0 0-3.61 0l-9.626 9.44a.863.863 0 0 1-1.203 0 .822.822 0 0 1 0-1.18l9.626-9.44a4.313 4.313 0 0 1 6.016 0 4.117 4.117 0 0 1 1.204 3.54 4.3 4.3 0 0 1 3.61 1.18l.05.05a4.115 4.115 0 0 1 0 5.9l-8.707 8.537a.273.273 0 0 0 0 .393l1.788 1.754a.823.823 0 0 1 0 1.18.863.863 0 0 1-1.203 0l-1.788-1.753a1.921 1.921 0 0 1 0-2.754l8.706-8.538a2.471 2.471 0 0 0 0-3.54l-.05-.049a2.588 2.588 0 0 0-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 0 1-1.204 0 .822.822 0 0 1 0-1.18l7.273-7.133a2.47 2.47 0 0 0-.003-3.537Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.485 4.703a.822.822 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a4.114 4.114 0 0 0 0 5.9 4.314 4.314 0 0 0 6.016 0l7.12-6.982a.822.822 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a2.588 2.588 0 0 1-3.61 0 2.47 2.47 0 0 1 0-3.54l7.12-6.982Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
